import { render } from "./PriceTag.vue?vue&type=template&id=2c93c6ee&scoped=true&ts=true"
import script from "./PriceTag.vue?vue&type=script&lang=ts"
export * from "./PriceTag.vue?vue&type=script&lang=ts"

import "./PriceTag.vue?vue&type=style&index=0&id=2c93c6ee&scoped=true&lang=css"

import exportComponent from "/tmp/nginx/vue-single-page-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c93c6ee"]])

export default __exports__